export default __webpack_public_path__ + "static/media/trash.b14d69fe.svg";